import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { isTankType, TANK_TYPES } from "../valueObjects/tankTypes";
import { assertBoolean, assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createTank = ({
  id = createUuid(),
  vesselId,
  name,
  tankType = TANK_TYPES.OTHER,
  capacity,
  coating,
  properties = {},
  active = true,
  createdAt = nowIso(),
  updatedAt = createdAt,
}) => {
  assertString(id, "tank.id");
  assertString(vesselId, "tank.vesselId");
  assertString(name, "tank.name");
  assertBoolean(active, "tank.active");

  if (!isTankType(tankType)) {
    throw new Error("tank.tankType must be a valid tank type");
  }

  return {
    id,
    vesselId,
    name,
    tankType,
    capacity,
    coating,
    properties,
    active,
    createdAt,
    updatedAt,
    schemaVersion: SCHEMA_VERSIONS.TANK,
  };
};
